import {Injectable} from '@angular/core';
import {ProfileFilters} from "../model/filters/profile-filters";
import {Observable} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {HttpUtils} from "../shared/http.utils";
import {ProfilePersistRequest} from "../model/requests/profile-persist-request";
import {FiltersUtils} from "../shared/filters.utils";

@Injectable({
  providedIn: 'root'
})
export class ProfilesService {

  private readonly profilesURL: string;


  constructor(private http: HttpClient) {
    this.profilesURL = '/api/profiles';
  }

  getProfiles(offset: number, limit: number, filters: ProfileFilters): Observable<any> {
    let options = HttpUtils.buildOptions(HttpUtils.buildListParams(offset, limit));
    if (filters != null) {
      options.params["name"] = FiltersUtils.getFilterTrim(filters.name);
      options.params["from"] = FiltersUtils.getFilter(filters.from);
      options.params["until"] = FiltersUtils.getFilter(filters.until);
      options.params["permission"] = FiltersUtils.getFilterTrim(filters.permission);
    }
    return this.http.get<any>(this.profilesURL, options);
  }

  getProfilesSummary(): Observable<any> {
    const url: string = `${this.profilesURL}` + "/summary";
    return this.http.get<any>(url);
  }

  getUsersWithProfile(profileUuid: string): Observable<any> {
    const url: string = `${this.profilesURL}/users/${profileUuid}`;
    return this.http.get<any>(url);
  }

  getProfile(profileUuid: string): Observable<any> {
    const url: string = `${this.profilesURL}/${profileUuid}`;
    return this.http.get<any>(url);
  }

  createProfile(profileData: ProfilePersistRequest): Observable<any> {
    return this.http.post<any>(this.profilesURL, profileData);
  }

  editProfile(profileData: ProfilePersistRequest): Observable<any> {
    const url: string = `${this.profilesURL}/${profileData.profileUuid}`;
    return this.http.put<any>(url, profileData);
  }

  deleteProfile(profileUuid: string): Observable<any> {
    const url: string = `${this.profilesURL}/${profileUuid}`;
    return this.http.delete<any>(url, {observe: 'response'});
  }

  deleteAndReassignProfile(profileUuid: string, profileToReassignUuid): Observable<any> {
    const url: string = `${this.profilesURL}/${profileUuid}/reassign`;
    let options = HttpUtils.buildOptions(HttpUtils.buildListParams());
    options.params["profileToReassignUuid"] = profileToReassignUuid;
    return this.http.delete<any>(url, options);
  }

}
